import { ArrowPositions } from '@/apps/mwd-v2/state/types/TooltipStore';
import { Station } from '@/components/detailPanel/types/types';

import styles from './MwdTooltip.module.css';

const DetailPanelOnSpoorTooltipInformation = ({ data }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', overflow: 'hidden' }}>
    {(data.actueelSpoor || data.geplandSpoor) && (
      <div>
        <span style={{ fontWeight: 400 }}>Spoor </span>
        <span
          style={{
            textDecoration: 'line-through',
            paddingRight: '4px',
            fontWeight: 500,
          }}
        >
          {data.geplandSpoor}
        </span>
        <span
          style={{
            fontWeight: 500,
            color: 'var(--tractie-color-content-error-inverse)',
          }}
        >
          {data.actueelSpoor}
        </span>
      </div>
    )}
  </div>
);
const DetailPanelOnSpoorTooltipContent = ({
  data,
  arrowPosition,
}: {
  data: Station;
  arrowPosition: ArrowPositions;
}) => {
  return (
    <div
      data-testid='detail-panel-tooltip'
      className={arrowPosition === 'bottom' ? styles.legendRightBottomTooltipStyle : styles.legendRightTopTooltipStyle}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <span>
          <DetailPanelOnSpoorTooltipInformation data={data} />
        </span>
      </div>
    </div>
  );
};

export default DetailPanelOnSpoorTooltipContent;
